export const SET_CONTACTS = 'SET_CONTACTS';
export const SET_CHILDREN = 'SET_CHILDREN';
export const SET_CHILDREN_LIST = 'SET_CHILDREN_LIST';
export const SET_CONTACT_ROSTER_DATA = 'SET_CONTACT_ROSTER_DATA';
export const SET_CONTACT_GENERAL_DATA = 'SET_CONTACT_GENERAL_DATA';
export const SET_CONTACT_SCHEDULE_DATA = 'SET_CONTACT_SCHEDULE_DATA';
export const REMOVE_CONTACT_ROSTER_DATA = 'REMOVE_CONTACT_ROSTER_DATA';
export const REMOVE_CONTACT_GENERAL_DATA = 'REMOVE_CONTACT_GENERAL_DATA';
export const REMOVE_CONTACT_SCHEDULE_DATA = 'REMOVE_CONTACT_SCHEDULE_DATA';


// WEBPACK FOOTER //
// ./src/store/modules/children/mutations.js